import { useFormik, FormikValues, FormikErrors, FormikTouched } from 'formik';

export type TFormValues = FormikValues;
export type TFormErrors<Values> = FormikErrors<Values>;
export type TFormTouched<Values> = FormikTouched<Values>;

export const useForm = useFormik;
